import { useEffect, useContext, useState } from "react";
import { Select, Typography } from "antd";
import TableContext from "../tableContext";
import sortBy from "lodash/sortBy";
import uniqBy from "lodash/uniqBy";

const { Text } = Typography;

const { Option } = Select;

const SearchBox = () => {
  const { dataSource, search } = useContext(TableContext);
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(
      sortBy(
        uniqBy(dataSource.map((x) => x.searchValues).flat(), "value"),
        ["label", "value"],
        ["asc", "asc"]
      )
    );
  }, [dataSource]);

  const handleSearch = (val) => {
    if (!val || (val && val.length === 0)) {
      setData(
        sortBy(
          uniqBy(dataSource.map((x) => x.searchValues).flat(), "value"),
          ["label", "value"],
          ["asc", "asc"]
        )
      );
      return;
    }

    let str = val.toLocaleLowerCase("tr");
    const filter = dataSource
      .map((x) => x.searchValues)
      .flat()
      .filter((x) => x.searchStr.includes(str));
    const arr = sortBy(
      uniqBy(filter, "value"),
      ["label", "value"],
      ["asc", "asc"]
    );
    setData(arr);
  };

  return (
    <Select
      style={{ width: "100%" }}
      showSearch
      allowClear
      placeholder="Arama yap veya filtrele"
      mode="tags"
      onSearch={(val) => handleSearch(val)}
      filterOption={false}
      onChange={(vals) => search(vals)}
      tokenSeparators={[","]}
      showArrow
    >
      {data.map((item, index) => {
        if (item) {
          return (
            <Option value={item.searchStr} key={index}>
              <Text type="secondary">{item.label}:</Text>{" "}
              <Text>{item.value}</Text>
            </Option>
          );
        }
        return null;
      })}
    </Select>
  );
};

export default SearchBox;
